import React from 'react'
import TableChaise from '../../../Components/table/TableChaise'

const Chaises = () => {
  return <TableChaise />
}

export default Chaises
